declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xxs: true;
  }
}

export const customBreakpoints = {
  xl: 1680,
  lg: 1320,
  md: 950,
  sm: 600,
  xs: 400,
  xxs: 0,
};
